export const certificateTemplateList = "CERTIFICATE_TEMPLATE_LIST";
export const traineesCertificate = "TRAINEES_CERTIFICATE";